import { Children, isValidElement, ReactNode } from 'react'

const elementTag = (node: ReactNode): string | null => {
  if (isValidElement(node) && typeof node.type === 'string') {
    return node.type
  }
  return null
}

const childrenOf = (node: ReactNode): ReactNode => {
  if (!isValidElement(node)) return null
  return (node.props as { children?: ReactNode }).children ?? null
}

const extractText = (node: ReactNode): string => {
  if (node === null || node === undefined || typeof node === 'boolean') return ''
  if (typeof node === 'string' || typeof node === 'number') return String(node)
  if (Array.isArray(node)) return node.map(extractText).join('')
  if (isValidElement(node)) return extractText(childrenOf(node))
  return ''
}

const findChild = (children: ReactNode, tag: string): ReactNode => {
  for (const child of Children.toArray(children)) {
    if (elementTag(child) === tag) return child
  }
  return null
}

const cellsFromRow = (row: ReactNode): string[] =>
  Children.toArray(childrenOf(row))
    .filter((c) => elementTag(c) === 'th' || elementTag(c) === 'td')
    .map((cell) => extractText(childrenOf(cell)).trim())

const rowsFromSection = (section: ReactNode): string[][] =>
  Children.toArray(childrenOf(section))
    .filter((c) => elementTag(c) === 'tr')
    .map(cellsFromRow)

export const parseMarkdownTable = (children: ReactNode): { headers: string[]; rows: string[][] } => {
  const headerRows = rowsFromSection(findChild(children, 'thead'))
  const bodyRows = rowsFromSection(findChild(children, 'tbody'))
  return { headers: headerRows[0] ?? [], rows: bodyRows }
}
